 export const ErrorType = {
    AppMapping: 1,
    Theme: 2,
    CampaignId: 3,
    Locale: 4,
    ReturnUrl: 5,
    Version: 6, 
    AppId: 7, 
    Serial: 8, 
    AccessKeyExpire: 9,
};